export default __webpack_public_path__ + "static/media/icon.54fc5517.png";